const options = {
  5: "bg-red-800/5",
  10: "bg-red-800/10",
  25: "bg-red-800/25",
  50: "bg-red-800/50",
  75: "bg-red-800/75",
  90: "bg-red-800/90",
  100: "bg-red-800",
};

const from = {
  5: "from-red-800/5",
  10: "from-red-800/10",
  25: "from-red-800/25",
  50: "from-red-800/50",
  75: "from-red-800/75",
  90: "from-red-800/90",
  100: "from-red-800",
};

export default function getBackgroundRed800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
